import { useEffect } from 'react';

const SITE_URL = 'https://craigphotoletters.com';

function Seo({ title, description, canonicalPath }) {
  useEffect(() => {
    const previousTitle = document.title;
    let meta = document.querySelector('meta[name="description"]');
    let canonical = document.querySelector('link[rel="canonical"]');
    const createdMeta = !meta;
    const createdCanonical = !canonical;
    const previousDescription = meta?.getAttribute('content');
    const previousCanonical = canonical?.getAttribute('href');

    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    document.title = title;
    meta.setAttribute('content', description);
    canonical.setAttribute('href', `${SITE_URL}${canonicalPath}`);

    return () => {
      document.title = previousTitle;
      if (createdMeta) meta.remove();
      else meta.setAttribute('content', previousDescription || '');
      if (createdCanonical) canonical.remove();
      else canonical.setAttribute('href', previousCanonical || '');
    };
  }, [title, description, canonicalPath]);

  return null;
}

export default Seo;
